import React from 'react'
import './Footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {FiTwitter} from 'react-icons/fi'
import {SiMedium} from 'react-icons/si'
import {SiGithub} from 'react-icons/si'


const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'></a>
      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#testimonial">Projects</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className='footer_socials'>
        <a href="https://www.facebook.com/profile.php?id=100007902782009"><FaFacebookF/></a>
        <a href="https://www.instagram.com/i.a.m.k.r.i.s.h.n.a/"><FiInstagram/></a>
        <a href="https://twitter.com/The_Krishna1"><FiTwitter/></a>
        <a href="https://medium.com/@kumarkrishn663"><SiMedium/></a>
        <a href="https://github.com/i-am-Krishna"><SiGithub/></a>


      </div>
<div className='footer_copyright'>

<small>&copy; Krishna. All rights reserved.</small>
</div>

    </footer>
  )
}

export default Footer